import { IMAGE_URL } from "../../path";

interface ImageProps {
    id: number;
    caption: string | null;
    isFullWidth: boolean;
    image_path: string;
}

function CustomImageComponent(props: ImageProps) {
    const containerWidth = props.isFullWidth ? '100%' : '70%';

    return (
        <div style={{ width: containerWidth, margin: '0 auto', marginBottom: '100px' }} key={props.id}>
            <img
                src={IMAGE_URL + props.image_path}
                alt={props.caption || ''}
                style={{
                    width: '100%', // image fills the div width
                    maxWidth: '100%', // prevent image from exceeding natural size
                    height: 'auto', // maintain aspect ratio
                    display: 'block',
                }}
            />
            {props.caption && (
                <p style={{ textAlign: 'center', fontSize: '12px', marginTop: '4px' }}>
                    {props.caption}
                </p>
            )}
        </div>
    );
}

export default CustomImageComponent;
